module.exports = __webpack_public_path__ + "images/emoji/two_hearts.4131d9afb6a0d57ad0b8.png";